import cn from "classnames";
import { format, isValid, parseISO } from "date-fns";
import { useFormikContext } from "formik";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import i from "@styles/icons.module.scss";
import DatePicker from "@ui-kit/DatePicker/DatePicker";
import Popper from "@ui-kit/Popper/Popper";
import TicketsInput from "@ui-kit/TicketsInput/TicketsInput";
import { localizedDate } from "@utils/utils";

import s from "./BirthDateField.module.scss";

const BirthDateField = ({ className, disabled, clearable = true }) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const {
    values,
    touched,
    errors,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();
  const birthDate = values.birthDate ? parseISO(values.birthDate) : undefined;
  const selectedBirthDate = isValid(birthDate) ? birthDate : undefined;
  const today = new Date();

  return (
    <div className={cn(s.birthDate, className)}>
      <Popper
        isRenderPoper={!disabled}
        triggerElement={
          <TicketsInput
            name="birthDate"
            type="text"
            label={t("date of birth")}
            placeholder={t("pick the date")}
            value={
              selectedBirthDate
                ? localizedDate(selectedBirthDate, "d MMM yyyy", locale)
                : ""
            }
            readOnly
            disabled={disabled}
            onBlur={handleBlur}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                event.currentTarget.click();
              } else if (event.key === "Backspace" || event.key === "Delete") {
                event.preventDefault();
                if (clearable) setFieldValue("birthDate", "");
              }
            }}
            errors={touched.birthDate && errors.birthDate}
          />
        }
        popperContent={
          <DatePicker
            defaultMonth={selectedBirthDate || today}
            selected={selectedBirthDate}
            required={!clearable}
            fromDate={parseISO("0001-01-01")}
            toDate={today}
            disabled={[{ after: today }]}
            onSelect={(date) => {
              setFieldTouched("birthDate", true, false);
              setFieldValue("birthDate", format(date, "yyyy-MM-dd"));
            }}
          />
        }
      />
      {clearable && values.birthDate && (
        <button
          type="button"
          className={s.clearDate}
          aria-label={`${t("clear")}: ${t("date of birth")}`}
          title={t("clear")}
          disabled={disabled}
          onClick={() => setFieldValue("birthDate", "")}
        >
          <icon className={i.close} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default BirthDateField;
